
    // this file was auto generated by python script
    import Move from './Move';
    export default Move;
    